import React, { useEffect, useState, useRef } from 'react';
import logo from '../../images/logo.jpeg'
import './Profile.css'
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../url';
export default function Profile() {
    const [contactos, setContactos] = useState([]);

    useEffect(() => {
        //cargarContacto();

    }, []);


    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                debugger
                setContactos(data.contacto.reverse()[0] || []);

            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    return (
        <div className='profileContain'>
            {/* <img src={logo} alt="" />
            <h2>{contactos.nombre}</h2> */}



        </div>
    )
}
